import React from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode.react';
import styles from './WhatsApp.module.scss';
import { getWhatsappNumber } from '../../utils/OrderUtils';
import { ReactComponent as WhatsappIcon } from '../../svgs/whatsapp.svg';

function WhatsApp() {
  const { t } = useTranslation('common');
  const message = t('whatsapp.message');
  const whatsappNumber = getWhatsappNumber();
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className={styles.whatsappContainer}>
      <p className={styles.instructionText}>{t('whatsapp.text')}</p>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.qrCodeLink}
        aria-label={t('whatsapp.aria_label')}
      >
        <div className={styles.qrCodeWrapper}>
          <QRCode value={whatsappUrl} size={220} />
          <div className={styles.iconOverlay}>
            <WhatsappIcon />
          </div>
        </div>
      </a>
    </div>
  );
}

export default WhatsApp;
